import React from 'react';
import { render } from 'react-dom';

const { Rollbar } = window;

const renderReactComponent = (Component) => (id, options) => {
  const target = document.getElementById(id);
  if (target) {
    render(<Component {...options} />, target);
  } else if (Rollbar) {
    Rollbar.warning(
      `Could not find element with ID ${id} to launch React Component ${Component}`
    );
  }
};

export default renderReactComponent;
